<template>
  <div class="cart orderList">
    <h1 class="boxTitle mb15 notranslate">{{locale.order_list}}</h1>
    <div v-if="list.length" class="list">
      <OrderListItem
        v-for="item in list"
        :key="item.order_id"
        :itemList="item"
        :locale="locale"
        :lang="lang" />
    </div>
    <div v-else class="noData notranslate">{{locale.order_nodata}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrderListItem from '@/components/Mypage/OrderListItem'

export default {
  name: 'OrderList',
  props: [
    'lang',
    'locale'
  ],
  components: {
    OrderListItem
  },
  computed: {
    ...mapGetters({
      metaInfo: 'authentication/getMetaInfo'
    })
  },
  async mounted () {
    // 주문내역에서 제외할 전송코드
    const notInclude = /reservation|morningcall|parking|mobility|tip/
    this.$store.commit('loading', true)
    await this.getKey()
    this.$store.dispatch('submit/getOrderHistory').then((res) => {
      if (res && res.orderLog && res.paidLog) {
        this.list = res.orderLog.filter(x => {
          return x.order_type && !notInclude.test(x.order_type)
        }).map(x => {
          return {
            ...x,
            ordersheet: x.ordersheet.length ? x.ordersheet : [x.ordersheet],
            isPaid: res.paidLog.filter(p => p.orderId === x.receiptId).length > 0
          }
        }) || []
      }
      this.$store.commit('loading', false)
    })
  },
  data () {
    return {
      list: [],
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'orderList'
      })
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    init () {
      this.track()
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  text-align: center;
}
</style>
